// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jEIe","colMin":"styles_colMin__TMeqK"};